import '../../themes/global.scss';
import '../../themes/mapactiveoffer.scss';

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Colors } from '../../themes/colors';
import { RemoteConfigUtils } from '../../utils/RemoteConfigUtils';

import { Link, useParams } from 'react-router';
import { BackButton, Box, CardSpinner, Text } from '~/commonComponents';
import { InviteProfessional } from '~/commonComponents/InviteProfessional';
import history from '~/history';
import { getIsAllowOfficeToPostProcedure } from '~/utils/DentistUtils';
import {
  CANCEL_JOB_ACTION,
  cancelJob,
  DECLINE_COUNTER_OFFER,
  FETCH_JOB_ACTION,
  fetchJob,
  UPDATE_JOB_ACTION,
} from '../../actions';
import { UserProfession, UserSubProfession } from '../../enums/UserProfession';
import useLoading from '../../hooks/useLoading';
import CloseIcon from '../../images/icons/CloseIcon';
import EditPencilIcon from '../../images/icons/EditPencil';
import TrashIcon from '../../images/icons/Trash';
import repostWhiteIcon from '../../images/repost-white.svg';
import { formatFromMinuteToFormattedHour } from '../../utils/DateUtils';
import { EducationUtils } from '../../utils/EducationUtils';
import AnimatedCloseCircle from '../shared/AnimatedCloseCircle';
import ConfirmPopup from '../shared/ConfirmPopup';
import Tooltip from '../Tooltip';

export default function OpenJobScreen() {
  const params = useParams();
  const dispatch = useDispatch();

  const jobId = history.location.state ? history.location.state?.jobId : params?.jobId;
  const job = useSelector((state) => (jobId === state.job.job?.id ? state.job.job : null));

  const tooltipDescription = (
    <>
      Professional’s eligibility criteria:
      <br />
      <br />
      {'\u2022  '}
      Has at least a {RemoteConfigUtils.getAutofillMinAttendanceScore()}% attendance score for
      previous shifts worked.
      <br />
      {'\u2022  '}
      Has a minimum of 2 years working experience.
      <br />
      {'\u2022  '}
      Has received exceptional performance ratings on over 95% of completed shifts.
      <br />
      {'\u2022  '}
      Has completed at least 3 shifts.
      <br />
      <br />
      Note: You may change your auto-confirm preference at any time by visiting the Shift Details
      page.
    </>
  );

  const { subProfession, specialty, procedures, profession, professionName } = job || {};

  // show "repost as DA" button only for EFDA
  const shouldShowRepostButton =
    subProfession === UserSubProfession.EFDA && !job?.isOnsiteInterview;

  const { isLoading } = useLoading([
    FETCH_JOB_ACTION,
    UPDATE_JOB_ACTION,
    DECLINE_COUNTER_OFFER,
    CANCEL_JOB_ACTION,
  ]);

  const [cancelJobPopup, setCancelJobPopup] = useState(false);
  const professionTypeCode = UserProfession.getNormalizedCode(profession);

  useEffect(() => {
    dispatch(fetchJob({ jobId }));
  }, []);

  useEffect(() => {
    if (job && (job.status === 'pending' || job.status === 'counter')) {
      const candidateId = job?.multipleCounters?.[0]?.candidate?.id;
      history.replace(`/dashboard/job/${job.id}/confirm/${candidateId}`);
    } else if (
      job &&
      (job.status === 'filled' || job.status === 'pay-out' || job.status === 'complete')
    ) {
      history.replace(`/dashboard/job/${job.id}/details`);
    }
  }, [job]);

  const repostEfdaAsDa = () => {
    history.push('/dashboard/temp', {
      job: {
        ...job,
        subProfession: null,
      },
    });
  };

  if (isLoading || !job) {
    return <CardSpinner />;
  }

  return (
    <div className="component_container global_font">
      <div className="floating_container">
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              width: '95%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingTop: 40,
            }}
          >
            {history.location.state?.isJobPost ? (
              <div
                onClick={() => history.push('/dashboard/home')}
                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
              >
                <CloseIcon color={Colors.secondary_500} />

                <p
                  style={{
                    fontFamily: 'Nunito',
                    fontWeight: 'bold',
                    fontSize: 20,
                    color: Colors.secondary_500,
                    marginLeft: 8,
                  }}
                >
                  Close
                </p>
              </div>
            ) : (
              <BackButton />
            )}

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div
                onClick={() => history.push(`/dashboard/job/${jobId}/edit`)}
                className="buttons-container"
                data-cy="edit-shift-button"
                style={{
                  marginRight: 40,
                }}
              >
                <div className="edit-button">
                  <EditPencilIcon className="icon" color="#FFFFFF" />
                </div>
                <p>Edit</p>
              </div>
              <div className="buttons-container">
                <div
                  className="trash-button"
                  data-cy="cancel-shift-button"
                  onClick={() => setCancelJobPopup(true)}
                >
                  <TrashIcon className="icon" color="#FFFFFF" />
                </div>
                <p>Cancel</p>
              </div>
            </div>
          </div>
          <div style={{ width: '70%', paddingTop: 20 }}>
            <h1
              className="f-dark"
              style={{
                fontSize: 32,
                fontWeight: 'bold',
                marginTop: 20,
                textAlign: 'center',
                width: '100%',
              }}
            >
              {job?.isOnsiteInterview ? 'Interview Details' : 'Shift Details'}
            </h1>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ width: 500, display: 'flex', flexDirection: 'column' }}>
                <div className="row_style">
                  <p
                    style={{
                      margin: 0,
                      color: Colors.neutral_600,
                      fontSize: 18,
                      width: '40%',
                    }}
                  >
                    <b>Office:</b>
                  </p>
                  <p style={{ margin: 0, color: Colors.neutral_500, fontSize: 16 }}>
                    {job.offer_owner.office_name}
                  </p>
                </div>

                {job?.isOnsiteInterview && (
                  <div className="row_style">
                    <p
                      style={{
                        margin: 0,
                        color: Colors.neutral_600,
                        fontSize: 18,
                        width: '40%',
                      }}
                    >
                      <b>Job Title:</b>
                    </p>
                    <Box alignItems="center" justifyContent="flex-end">
                      <Link to={`/permanent-jobs/job-overview/${job?.postingId}`}>
                        <Text color={Colors.neutral_500} textDecoration="underline">
                          {job?.postingTitle}
                        </Text>
                      </Link>
                    </Box>
                  </div>
                )}

                <div className="row_style">
                  <p
                    style={{
                      margin: 0,
                      color: Colors.neutral_600,
                      fontSize: 18,
                      width: '40%',
                    }}
                  >
                    <b>Date:</b>
                  </p>
                  <p style={{ margin: 0, color: Colors.neutral_500, fontSize: 16 }}>
                    {job.local_date}
                  </p>
                </div>
                <div className="row_style">
                  <p
                    style={{
                      margin: 0,
                      color: Colors.neutral_600,
                      fontSize: 18,
                      width: '40%',
                    }}
                  >
                    <b>Professional Type:</b>
                  </p>
                  <p style={{ margin: 0, color: Colors.neutral_500, fontSize: 16 }}>
                    {UserSubProfession.getName(subProfession) ?? professionName}
                  </p>
                </div>

                <div className="row_style">
                  <p
                    style={{
                      margin: 0,
                      color: Colors.neutral_600,
                      fontSize: 18,
                      width: '40%',
                    }}
                  >
                    <b>Preferred Specialty:</b>
                  </p>
                  <p
                    style={{
                      margin: 0,
                      color: Colors.neutral_500,
                      fontSize: 16,
                      textTransform: 'capitalize',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {specialty?.split('_')?.[1] || 'General'}
                  </p>
                </div>

                {professionTypeCode === UserProfession.RDH && (
                  <div className="row_style">
                    <p
                      style={{
                        margin: 0,
                        color: Colors.neutral_600,
                        fontSize: 18,
                        width: '50%',
                      }}
                    >
                      <b>Assisted Hygiene Available:</b>
                    </p>
                    <p
                      style={{
                        margin: 0,
                        color: Colors.neutral_500,
                        fontSize: 16,
                        textTransform: 'capitalize',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {job.isAssistedHygiene ? 'Yes' : 'No'}
                    </p>
                  </div>
                )}

                {getIsAllowOfficeToPostProcedure(
                  UserSubProfession.getName(subProfession) ?? professionName,
                  specialty,
                ) &&
                  procedures &&
                  procedures.length > 0 && (
                    <div
                      style={{
                        borderBottom: '1px solid #ededed',
                      }}
                    >
                      <div
                        className="row_style"
                        style={{
                          border: 0,
                        }}
                      >
                        <p
                          style={{
                            margin: 0,
                            color: Colors.neutral_600,
                            fontSize: 18,
                          }}
                        >
                          <b>Shift Procedure(s):</b>
                        </p>
                      </div>

                      <ul
                        style={{
                          color: Colors.neutral_600,
                          fontSize: 18,
                          marginTop: 0,
                        }}
                      >
                        {EducationUtils.mapToRemoveProcedurePrefix(procedures).map((procedure) => (
                          <li key={procedure}>{procedure}</li>
                        ))}
                      </ul>
                    </div>
                  )}

                <div className="row_style">
                  <p
                    style={{
                      margin: 0,
                      color: Colors.neutral_600,
                      fontSize: 18,
                      width: '40%',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <b>
                      Hours:
                      <span
                        style={{
                          fontSize: 12,
                          color: Colors.white,
                          background: Colors.neutral_300,
                          borderRadius: 10,
                          padding: '0 4px',
                          marginLeft: 4,
                          alignSelf: 'center',
                          height: 15,
                        }}
                      >
                        {job.local_timezone}
                      </span>
                    </b>
                  </p>
                  <p style={{ margin: 0, color: Colors.neutral_500, fontSize: 16 }}>
                    {`${job.local_start_time} - ${job.local_end_time}`}
                  </p>
                </div>
                <div className="row_style">
                  <p
                    style={{
                      margin: 0,
                      color: Colors.neutral_600,
                      fontSize: 18,
                      width: '40%',
                    }}
                  >
                    <b>Hourly Rate:</b>
                  </p>
                  <p style={{ margin: 0, color: Colors.neutral_500, fontSize: 16 }}>
                    ${job.rate.toFixed(2)}
                  </p>
                </div>
                <div className="row_style">
                  <p
                    style={{
                      margin: 0,
                      color: Colors.neutral_600,
                      fontSize: 18,
                      width: '40%',
                    }}
                  >
                    <b>Meal Break:</b>
                  </p>
                  <p style={{ margin: 0, color: Colors.neutral_500, fontSize: 16 }}>
                    {formatFromMinuteToFormattedHour(job.lunch_break_time)}
                    {job.is_lunch_break_paid ? ' (Paid)' : ' (Unpaid)'}
                  </p>
                </div>
                {!job?.isOnsiteInterview && (
                  <div
                    className="row_style"
                    style={{ alignItems: 'flex-start', paddingBottom: 20 }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        width: '40%',
                        alignItems: 'center',
                      }}
                    >
                      <b style={{ color: Colors.neutral_600, fontSize: 18 }}>Auto-Confirm:</b>
                      <div
                        style={{
                          marginLeft: 8,
                          position: 'relative',
                          top: '2px',
                        }}
                      >
                        <Tooltip content={tooltipDescription} />
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 16,
                        color: Colors.neutral_500,
                        fontSize: 16,
                        textAlign: 'right',
                      }}
                    >
                      <span>Favorites / {job.autofillOptions?.favorite ? 'On' : 'Off'}</span>
                      <span>Eligible Professionals / {job.autoFill ? 'On' : 'Off'}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginBottom: 100,
                marginTop: 160,
              }}
            >
              {!job?.isOnsiteInterview && (
                <InviteProfessional
                  buttonText="Invite"
                  isRefetchJob={false}
                  shift={job}
                  source="shift_details"
                />
              )}

              {shouldShowRepostButton && (
                <button
                  className="button-reset"
                  type="button"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: Colors.secondary_500,
                    borderRadius: '50px',
                    width: 296,
                    height: 48,
                    cursor: 'pointer',
                    margin: '16px 0 8px',
                  }}
                  onClick={repostEfdaAsDa}
                >
                  <img
                    src={repostWhiteIcon}
                    alt="icon"
                    style={{ height: 24, width: 24, marginRight: 8 }}
                  />
                  <p
                    className="f-dark f-18"
                    style={{
                      textAlign: 'center',
                      color: Colors.white,
                    }}
                  >
                    <b>Repost as DA</b>
                  </p>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {cancelJobPopup && (
        <ConfirmPopup
          Icon={() => <AnimatedCloseCircle />}
          title="Are you sure you want to cancel?"
          titleStyle={{ marginTop: 20 }}
          description={
            job?.isOnsiteInterview
              ? 'Cancelling an open onsite interview means that it will no longer be available to professionals around your office to accept and potentially get interviewed.'
              : 'Cancelling an open shift means that it will no longer be available to professionals around your office to accept and potentially work.'
          }
          descriptionStyle={{ marginBottom: 50 }}
          leftButtonText="Go Back"
          leftButtonAction={() => setCancelJobPopup(false)}
          leftButtonDataCy="cancel-popup-go-back"
          rightButtonText={job?.isOnsiteInterview ? 'Cancel Interview' : 'Cancel Shift'}
          rightButtonDataCy="confirm-cancel-shift"
          rightButtonAction={() => {
            dispatch(cancelJob({ jobId: job.id, redirect: true }));

            setCancelJobPopup(false);
          }}
          leftButtonStyle={job?.isOnsiteInterview ? { width: 180 } : {}}
          rightButtonStyle={job?.isOnsiteInterview ? { width: 180 } : {}}
        />
      )}
    </div>
  );
}
